export default __webpack_public_path__ + "static/media/Arm Guards of the Earth Mother.5fdd9eab.jpg";